<template>
    <div class="wrapper">
        <CDataTable
                :items="items"
                :fields="fields"
                border
                :items-per-page="100"
                hover
                sorter
                @row-clicked="table_row_clicked"
                pagination
        >
            <!--        @row-clicked="table_row_clicked"-->

            <template v-for="field in fields" v-slot:[field.key]="{item,index}">

                <td v-if="index==0">
                    <CInput v-if="field._show== null"
                            :placeholder="[field.label]"

                            v-model="item[field.key]"
                            autocomplete="name"
                    />

                </td>
                <td v-else>
                    <p>{{ item[field.key] }}</p>
                </td>

            </template>
            <template #operation="{item,index}">
                <td v-if="index==0">
                    <CButton
                            color="primary"
                            variant="outline"
                            square
                            @click="item_add()"
                            size="sm"
                            :title="$t('buttons.edit')"
                    >
                        <CIcon name="cil-plus"/>
                    </CButton>

                </td>
                <td v-else>
                    <CButton class="m-1"
                             color="warning"
                             variant="outline"
                             square
                             @click="delete_item_dialog(item,index)"
                             size="sm"
                             :title="$t('buttons.delete')"
                    >
                        <CIcon name="cil-minus"/>
                    </CButton>
                    <CButton class="m-1"
                             color="warning"
                             variant="outline"
                             square
                             @click="item_edit(item,index)"
                             size="sm"
                             :title="$t('buttons.edit')"
                    >
                        <CIcon name="cil-pencil"/>
                    </CButton>

                </td>
            </template>

            <template #unit="{item,index}">
                <td v-if="index==0">
                    <CSelect
                            :value.sync="item.selected_unit"
                            @change="item.model = name_item+' '+unit_items.filter(x => x.value ==item.selected_unit )[0].label"
                            :options="unit_items"
                    >
                        <template #append-content>
                            <CIcon v-on:click.native="go_to_add_modal('unit')" name="cil-plus"/>
                        </template>
                    </CSelect>

                </td>
                <td v-else>
                    <p >{{ item.unit_name }}</p>

                </td>


            </template>
          <template #status="{item,index}">
            <td v-if="index==0">
              <CSelect
                  :placeholder="$t('tables.status')"
                  :value.sync="item.status"

                  :options="status_items"
              >
              </CSelect>
            </td>
            <td v-else>
              <p v-if="item.status==40">{{$t('deactivate')}}</p>
              <p v-else>{{$t('active')}}</p>

            </td>

          </template>
            <template #model="{item,index}">
                <td v-if="index==0">
                    <CInput
                            :placeholder="$t('components.productName')"
                            :value.sync="item.model"

                    />
                </td>
                <td v-else>
                    <p >{{ item.model }}</p>
                </td>
            </template>
            <template #item_code="{item,index}">
                <td >
                    <p v-if="index!=0" style="text-align: center">{{item.item_code}}</p>
                </td>
            </template>
            <template #inventory_code="{item,index}">
                <td >
                    <p v-if="index!=0" style="text-align: center">{{item.inventory_code}}</p>
                </td>
            </template>

        </CDataTable>


    </div>

</template>

<script>
    import {bus} from '../../../main';
    import Vue from 'vue';
    import VueToast from 'vue-toast-notification';
    // Import one of the available themes
    //import 'vue-toast-notification/dist/theme-default.css';
    import 'vue-toast-notification/dist/theme-sugar.css';
    import axios from "axios";

    Vue.use(VueToast);
    //Vue.$toast.open({/* options */});

    export default {
        name: 'Modals',
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                selected_unit: 0,
                status_form_delete: 0,
                status_form: 0,
            }
        },
        props: {
            items: Array,
            bus_prefix: String,
            name_item: String,

            fields: Array,
            align: String,
            selected_row: Number,
            unit_items: Array,
          status_items: Array,
        },
        mounted() {
            for (var x = 0; x < this.fields.length; x++) {
                this.fields[x]._style = this.fields[x]._style + ";text-align:" + this.align;
            }
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.item_delete();

                } else {
                    this.status_form_delete = 0;
                }
            });


        },
      watch:{
          'name_item':function (){
            try{
              this.items[0].model =  this.name_item+' '+this.unit_items.filter(x => x.value ==this.items[0].selected_unit )[0].label
            }catch (e) {

            }

          }
      },
      methods: {
            table_row_clicked(item, index, column) {
                console.log("inline table clicked", index, column)
                // this.selected_row = index
                if (column != "operation") {
                    bus.$emit(this.bus_prefix + "inline_table_row_clicked", index);

                }

            },

            item_add() {
                if (this.items[0].model == "" || this.items[0].selected_unit == 0) {

                    return false;
                }
                // if (this.items[0].barcode.length > 0) {
                //     if (this.items[0].barcode.length < 12 || this.items[0].barcode.length > 13) {
                //         Vue.$toast.open({
                //             message: this.$t('insertCorrectBarcode'),
                //             type: 'error',
                //             duration: 5000
                //             // all of other options may go here
                //         });
                //         return false;
                //     }
                // }

                var item = {};
                for (var x = 0; x < this.fields.length; x++) {
                    item[this.fields[x].key] = this.items[0][this.fields[x].key];
                    this.items[0][this.fields[x].key] = '';
                    if (this.fields[x].key == "unit") {
                        item.unit_name = this.unit_items.find(x => x.value === this.items[0].selected_unit).label;
                        item.unit = this.items[0].selected_unit;
                        item.selected_unit = this.items[0].selected_unit;
                        this.items[0].selected_unit = 0;
                    }

                }
                item.productId = this.items[0].productId
                if (this.status_form == 0) {
                    this.items.push(item);

                } else {
                    Vue.set(this.items, this.status_form, item)
                    this.status_form = 0;
                }
                console.log("inline adeed" + this.bus_prefix + "inline_table_row_add")
                var add_key = this.bus_prefix + "inline_table_row_add";
                bus.$emit(add_key, item);

            },
            item_edit(item, index) {
                // var item = [];
// this.items[0] = item;
                item.selected_unit = item.unit;
                console.log("edit item");
                // var editing_item = item;
                var editing_item = Object.assign({}, item);

                Vue.set(this.items, 0, editing_item)
                this.status_form = index;
            },
            item_delete() {
                bus.$emit(this.bus_prefix + "inline_table_row_delete", [this.items[this.status_form_delete],this.status_form_delete]);
                // this.delete_barcode_data(this.items[this.status_form_delete])

            },
            delete_item_dialog(item, index) {

                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.model]), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form_delete = index;

            },
            go_to_add_modal(func) {
                bus.$emit("show_add_base_modal", func);

                // this.$router.push({path:'/dashboard/base/categories/0'})
            },
            delete_barcode_data(item) {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DelProductBarCode";


                formData.append('ProductId', item.productId);

                axios.post(url, formData, {}).then((res) => {
                    //
                  self.$root.modal_component.show_api_response_modals(res);
                    if (res.data.statusCode == 0) {
                        self.items.splice(this.status_form_delete, 1);
                    }
                    // self.status_form = 0;

                    // self.get_lists();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

        }

    }
</script>
